/*
* fn [function] 需要防抖的函数
* delay [number] 毫秒，防抖期限值
*/
export default function(fn, delay){
  //闭包
  let timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/debounce.js